export const FilledLeftIcon = ({ fill }) => {

  return <>
    <svg width="100" height="100" viewBox="-6 2 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="m14 7-5 5 5 5V7z"></path>
    </svg>
  </>
}